var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMovieCollection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.0625) scale(0.275) translate(-14 -10)",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 76,
    height: 61,
    rx: 4,
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18,
    width: 10,
    height: 10,
    rx: 1.5,
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 32,
    width: 10,
    height: 10,
    rx: 1.5,
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 45,
    width: 10,
    height: 10,
    rx: 1.5,
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 58,
    width: 10,
    height: 10,
    rx: 1.5,
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 18,
    width: 10,
    height: 10,
    rx: 1.5,
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 32,
    width: 10,
    height: 10,
    rx: 1.5,
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 45,
    width: 10,
    height: 10,
    rx: 1.5,
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 58,
    width: 10,
    height: 10,
    rx: 1.5,
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41,30 41,54 65,42",
    fill: "currentColor",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieCollection);
export default __webpack_public_path__ + "static/media/movieCollection.8c20c7ac795592f50ba907980de7aada.svg";
export { ForwardRef as ReactComponent };